module.exports = __webpack_public_path__ + "img/biaoqian_gonggongtiyuchang.a777d542.png";